(function componentForm($, Adzuki) {
	'use strict';

	var form = {
		name: 'FlightSubmitBooking',
	};

	var form_id            = 'flightsubmitbooking-';
	var client_is_external = true;
	var responsible_client = null;
	var choose_cc          = null;
	var selected_cc_widget = null;
	var cardholder_country = null;
	var cardholder_state   = null;
	var selected_client_id = null;
	var gmt_username_radio = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		responsible_client = $('#' + form_id + 'client_id');
		choose_cc          = $('#' + form_id + 'client_credit_card_id');
		selected_cc_widget = $('.selected-cc');
		cardholder_country = $('#' + form_id + 'cardholder_country_id');
		cardholder_state   = $('#' + form_id + 'cardholder_state_id');
		selected_client_id = responsible_client.data('selected-client');
		gmt_username_radio = $('.gmt-user-switch');

		// when the resposible client changes
		responsible_client.change(function onResponsibleClientChange()
		{
			var client_id = $(this).val();

			hideAllCCFields();
			hideErrorHighlights();

			// show typeahead to search for a client
			if (client_id === 'existing') {
				$('.existing-client').toggleClass('hidden');
				$('.responsible-client').toggleClass('hidden');

				truncateCCOptions();
				choose_cc.attr('disabled', true);
				return;
			}

			// new client, no cc's on it yet since it doesn't exist yet
			if (client_id.indexOf('new') !== -1 || client_id === '') {
				truncateCCOptions();
				choose_cc.attr('disabled', false);
				return;
			}

			if (client_id) {
				populateClientCreditCards(client_id);
				populateClientAddresses(client_id);
			}
		});

		// when choosing a credit card
		choose_cc.change(function onCreditCardChange()
		{
			var credit_card_id = $(this).val();
			var url            = '/ClientCreditCards/get/' + credit_card_id;
			var existing_cc_id = choose_cc.data('selected-cc');

			hideErrorHighlights();

			if (credit_card_id) {
				// reset cc values, if a credit card
				// has not been selected for payment yet
				if (!existing_cc_id) {
					$('#' + form_id + 'cardholder_first_name').val('').focus();
					$('#' + form_id + 'cardholder_last_name').val('').focus();
					$('#' + form_id + 'credit_card_type_id').val('').trigger('change');
					$('#' + form_id + 'credit_card_number').val('');
					$('#' + form_id + 'credit_card_security_code').val('');
					$('#' + form_id + 'credit_card_expiration').val('');
					$('#' + form_id + 'credit_card_expiration_hidden').val('');
					$('#' + form_id + 'cardholder_address1').val('');
					$('#' + form_id + 'cardholder_address2').val('');
					$('#' + form_id + 'cardholder_city').val('');
					$('#' + form_id + 'cardholder_state_id').val('');
					$('#' + form_id + 'cardholder_country_id').val('');
					$('#' + form_id + 'cardholder_zipcode').val('');
				}

				if (credit_card_id === 'new') {
					// show all CC fields
					$('.existing-cc-fields').removeClass('hidden');
					$('.cc-fields').removeClass('hidden');
					$('.add-credit-card').removeClass('hidden');
					$('.make-primary-cc').removeClass('hidden');

					// hide selected CC details (if visible)
					selected_cc_widget.empty().addClass('hidden');

					// If payment data is in the session, use the data from there
					// unless it's explicitly changed in the form
					if (existing_cc_id) {
						cardholder_country.trigger('change');
						$('#' + form_id + 'credit_card_type_id').trigger('change');
						$('#' + form_id + 'add_credit_card').trigger('change');
					}

					return;
				}

				// show existing CC fields
				$('.existing-cc-fields').removeClass('hidden');

				// show address fields, but hide checkboxes to save the CC
				$('.cc-fields').removeClass('hidden');
				$('.add-credit-card').addClass('hidden');
				$('.make-primary-cc').addClass('hidden');

				// populate existing CC fields
				Adzuki.Ajax.get(url + '/1').then(function getCreditCardSuccess(credit_card)
				{
					var exp_date        = moment(credit_card.expiration, 'YYYY-MM-DD');
					var exp_year        = exp_date.year();
					var exp_month       = exp_date.month() + 1;
					var cardholder_name = [];
					var cc_first_name   = '';
					var cc_last_name    = '';
					var $cc_number      = $('#' + form_id + 'credit_card_number');
					var num_token       = (credit_card.number_token ? credit_card.number_token : null);
					var $ccv_number     = $('#' + form_id + 'credit_card_security_code');
					var ccv_token       = (credit_card.ccv_token ? credit_card.ccv_token : '');
					var secure_tokens   = [];

					if (exp_month < 10) {
						exp_month = '0' + String(exp_month);
					}

					// If payment data is in the session, use the data from there
					// unless it's explicitly changed in the form
					if (existing_cc_id) {
						cardholder_country.trigger('change');
						$('#' + form_id + 'credit_card_type_id').trigger('change');
						selectAmexCardType(credit_card.credit_card_type_branch_id);
						return;
					}

					// first name and last name fields are separate
					if (credit_card.name) {
						cardholder_name = credit_card.name.split(' ');

						if (cardholder_name.length > 1) {
							cc_first_name = cardholder_name[0];

							$.each(cardholder_name, function onEachName(i, str) {
								if (i !== 0) {
									cc_last_name += str + ' ';
								}
							});
						} else if (cardholder_name.length === 1) {
							cc_first_name = cardholder_name[0];
						}
					}

					$('#' + form_id + 'cardholder_first_name').val(cc_first_name);
					$('#' + form_id + 'cardholder_last_name').val(cc_last_name);
					$('#' + form_id + 'credit_card_type_id').val(credit_card.credit_card_type_id);
					$('#' + form_id + 'credit_card_type_id').trigger('change');

					if (num_token === null) {
						$cc_number.removeAttr('data-token');
						$ccv_number.removeAttr('data-ccv_token');

						$('.cc-num-ss-link').addClass('hidden');
						$('.cc-num-span').removeClass('input-group');

						$cc_number.val('').focus();
						$ccv_number.val('');
					} else {
						$('.cc-num-span').addClass('input-group');
						$('.cc-num-ss-link').removeClass('hidden');

						$cc_number.attr('data-token', num_token);
						$ccv_number.attr('data-ccv_token', ccv_token);

						secure_tokens[0] = num_token;

						if (ccv_token !== '') {
							secure_tokens[1] = ccv_token;
						}

						Adzuki.SecureStorage.detokenize({
							secure_storage_tokens: secure_tokens,
							success              : function success(plain_texts) {
								$cc_number.val(plain_texts[0]);

								if (plain_texts.length === 2) {
									$ccv_number.val(plain_texts[1]);
								}
							}
						});
					}

					$('#' + form_id + 'credit_card_expiration').val(exp_month + '/' + exp_year);
					$('#' + form_id + 'credit_card_expiration_hidden').val(exp_year + '-' + exp_month);

					// prepopulate any avaialable address fields
					if (credit_card.address1) {
						$('#' + form_id + 'cardholder_address1').val(credit_card.address1);
					}

					if (credit_card.address2) {
						$('#' + form_id + 'cardholder_address2').val(credit_card.address2);
					}

					if (credit_card.city) {
						$('#' + form_id + 'cardholder_city').val(credit_card.city);
					}

					if (parseInt(credit_card.country_id)) {
						$('#' + form_id + 'cardholder_country_id').val(credit_card.country_id);

						Adzuki.Address.countryChange(
							$('#' + form_id + 'cardholder_country_id')
						);
					}

					if (parseInt(credit_card.state_id)) {
						$('#' + form_id + 'cardholder_state_id').val(credit_card.state_id);

						Adzuki.Address.countryChange(
							$('#' + form_id + 'cardholder_country_id'),
							credit_card.state_id
						);
					}

					if (credit_card.zip) {
						$('#' + form_id + 'cardholder_zipcode').val(credit_card.zip);
					}

					// for AMEX cards, pre-select the AMEX card type
					selectAmexCardType(credit_card.credit_card_type_branch_id);
				});

				// show CC info
				Adzuki.Ajax.get(url).then(function getCreditCardSuccess(credit_card)
				{
					selected_cc_widget.empty()
									  .removeClass('hidden')
									  .append(credit_card);
				});
			} else {
				// hide CC fields
				$('.existing-cc-fields').addClass('hidden');
				$('.cc-fields').addClass('hidden');

				// hide CC details widget
				selected_cc_widget.addClass('hidden').empty();
			}
		});

		// When choosing a "Same as" address
		$('#' + form_id + 'client_address_id').change(function onClientAddressChange(event) {
			var address_id = $(this).val();

			if (address_id.length > 0) {
				Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id)
				.then(function onGetAddressSuccess(response) {
					if (response) {
						$('#' + form_id + 'cardholder_address1').val(response.address1);
						$('#' + form_id + 'cardholder_address2').val(response.address2);
						$('#' + form_id + 'cardholder_city').val(response.city);
						$('#' + form_id + 'cardholder_state_id').val(response.state_id);
						$('#' + form_id + 'cardholder_country_id').val(response.country_id);
						$('#' + form_id + 'cardholder_zipcode').val(response.zip);

						Adzuki.Address.countryChange(
							$('#' + form_id + 'cardholder_country_id'),
							response.state_id
						);
					}
				});
			} else {
				$('#' + form_id + 'cardholder_address1').val('');
				$('#' + form_id + 'cardholder_address2').val('');
				$('#' + form_id + 'cardholder_city').val('');
				$('#' + form_id + 'cardholder_state_id').val('');
				$('#' + form_id + 'cardholder_country_id').val('');
				$('#' + form_id + 'cardholder_zipcode').val('');
			}
		});

		// when the select drop down of cardholder country changes
		cardholder_country.change(function onCountryChange()
		{
			var state_id;

			// pre-select the state only if modifying a payment
			if (cardholder_state.data('selected-state') !== '') {
				state_id = cardholder_state.data('selected-state');
				cardholder_state.data('selected-state', '');
			}

			Adzuki.Address.countryChange($(this), state_id);
		});

		// when the credit card type changes
		// if AMEX, select an AMEX type
		$('#' + form_id + 'credit_card_type_id').change(function onCCTypeChange()
		{
			var credit_card_type = parseInt($(this).val());

			if (credit_card_type === 1) {
				$('.amex-card-type').removeClass('hidden');
			} else {
				$('.amex-card-type').addClass('hidden');
				$('#' + form_id + 'credit_card_type_branch_id').val('');
			}
		});

		// clicking on the close button to reset the client typeahead
		$('.close-client-typeahead').click(function onCloseTypeahead(event) {
			event.preventDefault();

			$('.existing-client').toggleClass('hidden');
			$('.responsible-client').toggleClass('hidden');

			$('#' + form_id + 'existing_client_id').val('');
			$('.existing-client-typeahead').val('');

			responsible_client.val('');
			responsible_client.trigger('change');

			truncateCCOptions();
			choose_cc.attr('disabled', true);
		});

		// setup existing client typeahead
		Adzuki.Typeahead(
			$('.existing-client-typeahead'),
			'/Searches/client/',
			function select(item, $self, typeahead) {
				if (item.id) {
					typeahead.setHiddenValue(item.id);

					hideAllCCFields();
					populateClientCreditCards(item.id);
					populateClientAddresses(item.id);
				} else {
					$('.existing-client-typeahead').val('');
				}
			}
		);

		// checking Add CC to client profile checkbox
		$('#' + form_id + 'add_credit_card').change(function onAddToProfileChange(event) {
			var is_checked            = $(this).is(':checked');
			var make_primary_checkbox = $('#' + form_id + 'make_primary');

			make_primary_checkbox.prop('disabled', !is_checked);

			if (!is_checked) {
				make_primary_checkbox.prop('checked', false);
			}
		});

		// click on flight rules link
		$('.flight-rules-btn').on('click', function onFlightRulesBtnClick(event)
		{
			event.preventDefault();

			$('.modal-title').text('Rules');
			$('.modal-body').html($('.flight-rules').html());
			$('.modal').modal('show');
		});

		// Toggling gmt username field
		gmt_username_radio.on('change', function onGmtUsernameRadioChange(event)
		{
			var agent_has_gmt_username = $(this).val();

			if (agent_has_gmt_username === '1') {
				$('.gmt-username-field').removeClass('hidden');
				return;
			}

			$('.gmt-username-field').addClass('hidden');
		});

		// when selecting a responsible client that is not part of the booking
		if (selected_client_id) {
			responsible_client.find('option').each(function onEachOption(index, el) {
				var client_id = $(el).val();

				if (
					client_id 
					&& client_id !== 'existing'
					&& parseInt(client_id) === selected_client_id
				) {
					client_is_external = false;
					return false;
				}
			});

			// Agent used a client that is not part of the booking
			// Select this external client and trigger events/populate cards and addresses
			if (client_is_external) {
				responsible_client.val('existing');
				responsible_client.trigger('change');

				// set hidden field value
				$('#' + form_id + 'existing_client_id').val(selected_client_id);

				// client name and email on client search text field
				if ($('#' + form_id + 'existing_client_search').data('selected-client-name')) {
					$('#' + form_id + 'existing_client_search').val(
						$('#' + form_id + 'existing_client_search').data('selected-client-name')
					);
				}

				populateClientCreditCards(selected_client_id);
				populateClientAddresses(selected_client_id);
			} else {
				// trigger responsible client change
				responsible_client.trigger('change');
			}
		} else {
			// trigger responsible client change
			responsible_client.trigger('change');
		}

		// trigger cc change
		choose_cc.trigger('change');
	};

	function populateClientCreditCards(client_id)
	{
		var url            = '/ClientCreditCards/getCardsByClientId/' + client_id + '/0';
		var existing_cc_id = choose_cc.data('selected-cc');

		Adzuki.Ajax.get(url).then(function onCreditCardsSuccess(credit_cards)
		{
			truncateCCOptions();

			$.each(credit_cards, function onEachCreditCard(credit_card_id, credit_card) {
				var markup = '';
				markup += '<option value="' + credit_card_id + '">';
				markup += credit_card;
				markup += '</option>';

				choose_cc.append(markup);
			});

			// pre-select cc when redirecting to this page if there's an error
			if (existing_cc_id) {
				if (existing_cc_id === 'manual') {
					existing_cc_id = 'new';
				}

				choose_cc.val(existing_cc_id);
				choose_cc.trigger('change');

				existing_cc_id = null;
				choose_cc.data('selected-cc', '');
			}
		});
	}

	function populateClientAddresses(client_id)
	{
		$('#' + form_id + 'client_address_id')
			.empty()
			.append('<option selected="1"></option>');

		if (client_id) {
			Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/' + client_id)
			.then(function success(response) {
				$.each(response, function parseAddresses(address_id, address) {
					var markup = '';
					markup += '<option value="' + address_id + '">';
					markup += address;
					markup += '</option>';

					if (address !== '') {
						$('#' + form_id + 'client_address_id').append(markup);
					}
				});
			});
		}
	}

	function truncateCCOptions()
	{
		choose_cc
			.empty()
			.removeAttr('disabled')
			.append('<option selected="1"></option>')
			.append('<option value="new">-- Enter Credit Card Info --</option>');
	}

	function hideAllCCFields()
	{
		$('.existing-cc-fields').addClass('hidden');
		$('.cc-fields').addClass('hidden');
		selected_cc_widget.empty().addClass('hidden');
	}

	function hideErrorHighlights()
	{
		$('.existing-cc-fields .form-group').removeClass('has-error');
		$('.cc-fields .form-group').removeClass('has-error');
	}

	function selectAmexCardType(branch_id)
	{
		if (parseInt(branch_id)) {
			$('#' + form_id + 'credit_card_type_branch_id')
				.val(branch_id);
		}
	}

}(jQuery, window.Adzuki || {}));
